import { useService } from "@policoders/di";
import Layout from "@shared/components/layout.component";
import { NavbarItem } from "@shared/components/navbar/navbar-item.model";
import NavbarService from "@shared/components/navbar/navbar.service";
import { Outlet } from "react-router-dom";

export const OverviewLayout: React.FC = () => {
  const items: NavbarItem[] = [{ label: "Início", to: "/overview", type: "nav-item" }];
  const navbar = useService<NavbarService>("NavbarService");
  navbar.set({ module: "overview", navbar: items });
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};
